"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CouponInput = void 0;

var Button_1 = require("../Button");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ToggleableInputField_1 = require("../InputField/ToggleableInputField");

var ApplyDiscountButton = styled_components_1.default(Button_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var CouponInputWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));

var CouponInput = function CouponInput(_a) {
  var _b = _a.placeholder,
      placeholder = _b === void 0 ? 'Your coupon code' : _b,
      handleApplyDiscount = _a.handleApplyDiscount,
      props = __rest(_a, ["placeholder", "handleApplyDiscount"]);

  return react_1.default.createElement(CouponInputWrapper, null, react_1.default.createElement(ToggleableInputField_1.ToggleableInputField, __assign({}, props, {
    "data-testid": "coupon-input-field",
    icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAxNiI+CiAgPGcgZmlsbD0iI0FBQSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgIDxwYXRoIGQ9Ik0wIDVjMS42NTYgMCAzIDEuMzQzIDMgM3MtMS4zNDQgMy0zIDN2NWgyOHYtNWMtMS42NTYgMC0zLTEuMzQzLTMtM3MxLjM0NC0zIDMtM1YwSDB2NXptMS00aDE4djJoMVYxaDd2My4xMjdDMjUuMjc3IDQuNTcxIDI0IDYuMTQgMjQgOGMwIDEuODYgMS4yNzcgMy40MjkgMyAzLjg3M1YxNWgtN3YtMmgtMXYySDF2LTMuMTI3QzIuNzIzIDExLjQyOSA0IDkuODYgNCA4YzAtMS44Ni0xLjI3Ny0zLjQyOS0zLTMuODczVjF6Ii8+CiAgICA8cGF0aCBkPSJNMTkgNGgxdjJoLTF6TTE5IDdoMXYyaC0xek0xOSAxMGgxdjJoLTF6TTcgNWg4djFIN3pNNyA3aDh2MUg3ek03IDEwaDR2MUg3eiIvPgogIDwvZz4KPC9zdmc+Cg==",
    placeholder: placeholder,
    button: function button() {
      return react_1.default.createElement(ApplyDiscountButton, {
        "data-testid": "apply-button",
        variant: Button_1.ButtonVariant.PRIMARY,
        onClick: function onClick(event) {
          if (handleApplyDiscount) {
            handleApplyDiscount(String(props.value));
          }

          event.preventDefault();
        }
      }, "Apply");
    }
  })));
};

exports.CouponInput = CouponInput;
var templateObject_1, templateObject_2;